<template>
    <v-main>
    <v-dialog max-width="520px" v-model="digTotpSet" persistent>
        <v-card>
            <v-card-title><span v-html="text.functionName.setTopt"></span></v-card-title>
            <v-card-text>
                <span v-html="text.messege.setTopt"></span>
                <v-divider></v-divider>
                <span v-html="text.messege.totpApp.text"></span>
                <v-container>
                    <v-row>
            <v-col class="pa-0">
                <v-container class="pa-0">
                <v-row class="pa-0">
                    <v-col cols="12">{{text.messege.totpApp.google.name}}</v-col>
                </v-row>
                <v-row class="pa-0">
                    <v-col cols="12" sm="6"><span v-html="text.messege.totpApp.google.andoroid_link"></span></v-col>
                    <v-col cols="12" sm="6"><span v-html="text.messege.totpApp.google.iOs_link"></span></v-col>
                </v-row>
                </v-container>
            </v-col>
            </v-row>
            <v-row>
            <v-col class="pa-0">
                <v-container class="pa-0">
                <v-row>
                    <v-col cols="12">{{text.messege.totpApp.microsoft.name}}</v-col>
                </v-row>
                <v-row class="pa-0">
                    <v-col cols="12" sm="6"><span v-html="text.messege.totpApp.microsoft.andoroid_link"></span></v-col>
                    <v-col cols="12" sm="6"><span v-html="text.messege.totpApp.microsoft.iOs_link"></span></v-col>
                </v-row>
                </v-container>
            </v-col>
            </v-row>
        </v-container>
        <v-divider></v-divider>
        <v-text-field id="login_Password" v-model="password" :label="text.password" :append-icon="showP ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showP ? 'text' : 'password'" @click:append="showP = !showP"></v-text-field>
        <v-btn @click="setTotpExec">{{text.functionName.totpSet}}</v-btn>
        <v-divider></v-divider>
        </v-card-text>
        <v-card-actions>
        <v-btn @click="digTotpSetClose">{{text.close}}</v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
    <v-dialog max-width="550px" v-model="digTotpInfo" :persistent = "!activateComplete">
    <v-card>
        <v-card-title>{{text.messege.totpInfo}}</v-card-title>
        <v-card-text>
        {{text.messege.totpInfoSecret}}<br>
        {{text.secretKey}}:<br>{{totpKey}}<br>
        <img :src="totpQrCode||undefined">
        </v-card-text>
        <v-card-actions>
        <div class="d-flex flex-column">
            <span v-show="!activateComplete">{{text.messege.activateTotp}}<br></span>
            <span v-show="activateComplete">{{text.messege.activateComp}}<br></span>
            <v-alert type="error" v-show="activateFail">{{text.messege.activateFail}}</v-alert>
            <v-text-field autocomplete="off" v-model="activateToken" :label="text.otpCode" v-show="!activateComplete"></v-text-field>
            <v-btn v-show="!activateComplete" :disabled="disActTotoBtn" @click="activateTotp">{{text.confn}}</v-btn>
            <v-btn v-show="!activateComplete" :disabled="disActTotoBtn" @click="digTotpInfo=false">{{text.cancel}}</v-btn>
            <v-btn v-show="activateComplete" @click="logout">{{text.close}}</v-btn>
        </div>
        </v-card-actions>
    </v-card>
    </v-dialog>
    <v-dialog max-width="520px" v-model="digChangePassword" persistent>
    <v-card>
        <v-form ref="password">
            <v-card-title>{{text.functionName.passwordChange}}</v-card-title>
            <v-card-text>
                <v-text-field v-model="currentPassword" :label="text.functionName.currentPassword" :type="showP ? 'text' : 'password'">
                    <template v-slot:append>
                    <v-icon tabindex="-1" @click="showP = !showP" v-show="showP">mdi-eye</v-icon>
                    <v-icon tabindex="-1" @click="showP = !showP" v-show="!showP">mdi-eye-off</v-icon>
                    </template>
                </v-text-field>
                <v-text-field @input="passWordScoreCheck" v-model="newPassword" :label="text.functionName.newPassword"
                    :type="showQ ? 'text' : 'password'" :rules="[passwordRule]" ref="newPassword">
                    <template v-slot:append>
                    <v-icon tabindex="-1" @click="showQ = !showQ" v-show="showQ">mdi-eye</v-icon>
                    <v-icon tabindex="-1" @click="showQ = !showQ" v-show="!showQ">mdi-eye-off</v-icon>
                    </template>
                </v-text-field>
                <div>
                <v-progress-linear :value="passwordScore.value" :color="passwordScore.color" height="25">
                    {{passwordScoreTxt}}
                </v-progress-linear>
                <span :class="passwordScore.color+'--text'">{{passwordWarning}}</span>
                </div>
                <v-text-field type="password" v-model="newPasswordV" :label="text.functionName.newPasswordV" :error="newPassChk.error" :error-messages="newPassChk.errMes"></v-text-field>
                <v-text-field autocomplete="off" id="login_otp" v-model="otpToken" :label="text.otpCode"></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-btn :disabled="disPasswordChgBtn" @click="changePasswordExec">{{text.chgPassword}}</v-btn>
                <v-btn @click="digChangePassword = false">{{text.cancel}}</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
    </v-dialog>
    <v-dialog max-width="520px" v-model="digClearTotp">
    <v-card>
        <v-card-title>{{text.functionName.totpCl}}</v-card-title>
        <v-card-text>
            <v-text-field v-model="password" :label="text.password" :type="showP ? 'text' : 'password'">
                <template v-slot:append>
                <v-icon tabindex="-1" @click="showP = !showP" v-show="showP">mdi-eye</v-icon>
                <v-icon tabindex="-1" @click="showP = !showP" v-show="!showP">mdi-eye-off</v-icon>
                </template>
            </v-text-field>
            <v-text-field autocomplete="off" id="login_otp" v-model="otpToken" :label="text.otpCode"></v-text-field>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="clearTotpExec">{{text.functionName.totpCl}}</v-btn>
            <v-btn @click="digClearTotp = false">{{text.cancel}}</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
    </v-main>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../lang";
    let text = new lang(0);
    import {ePasswordChangeStatus} from "../lib/api/api_response_type"
    import {apiRequest} from "../lib/api";
    import * as comm from '../common';

    interface vueRefForm extends Vue{
        validate:()=>boolean;
    }
    import zxcvbn, { ZXCVBNResult } from 'zxcvbn';
    import {getWarningMessege} from '../zxcvbnj';
    interface zxcvbnResultEx extends ZXCVBNResult{
        scoreRate:number;
        passwordRule:boolean|string
    }
    let passwordDic = ["password"];
    let userId = null as null|string;
    const checkZxcvbn = (value:string):zxcvbnResultEx=>{
        const maxScore = 17;
        const addDic = passwordDic.map(v=>{
        const _chrs:Array<string> = [];
        for(const c of comm.spacerChr){
            _chrs.push(`${v}${c}`);
        }
        return _chrs;
        }).flat();
        if(userId){
            addDic.push(userId);
        }
        const checkResult = zxcvbn(value,addDic);
        const scoreRate = (checkResult.guesses_log10 / maxScore)*100
        const rule = (()=>{
            //パスワードルールの定義
            if(value.length < 8){
                //8文字以上
                return text.Text.passwordRule
            }
            if(checkResult.feedback.warning.length > 0 || scoreRate < 35){
                    //スコア評価
                    return text.Text.passwordRuleScore
                }else{
                    return true
            }
        })();
        return {...checkResult,
        "scoreRate":scoreRate,
        "passwordRule":rule,
        }
    }
    export default Vue.extend({
        data: () => ({
            text:text.Text,
            disPasswordChgBtn:false,
            showP:false,
            showQ:false,
            passwordWarning:"",
            currentPassword:"",
            username:"",
            password:"",
            newPassword:"",
            newPasswordV:"",
            newPassChk:{
                error:false,
                errMes:"",
            },
            totpKey:"",
            otpToken:"",
            activateToken:"",
            totpQrCode:null as null|string,
            digTotpInfo:false,
            disUsermenu:true,
            digTotpSet:false,
            digClearTotp:false,
            digChangePassword:false,
            activateFail:false,
            disActTotoBtn:false,
            activateComplete:false,
            passwordScoreTxt:"",
            passwordRule:(value:string)=>{return checkZxcvbn(value).passwordRule},
            passwordScore:{
                value:0,
                color:"red"
            },
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
        }),
        mounted() {
            this.api = this.$store.state.apiSaver;
        },
        props:{
            userData:Object
        },
        methods:{
            reset(){
                //@ts-ignore
                Object.assign(this.$data,this.$options.data());
            },
            chgPassword(){
                this.showP = false;
                this.showQ = false;
                this.currentPassword = "";
                this.newPassword = "";
                this.otpToken = "";
                this.newPasswordV = "";
                this.newPassChk.error = false;
                this.newPassChk.errMes = "";
                this.disPasswordChgBtn = true;
                this.digChangePassword = true;
                if(this.userData){
                    userId = this.userData.userId;
                }
            },
            setTotp(){
                this.showP = false;
                this.password = "";
                this.otpToken = "";
                if(this.userData.totp){
                    this.digClearTotp = true;
                }else{
                    this.digTotpSet = true;
                }
            },
            async changePasswordExec(){
                const refForm = this.$refs.password as vueRefForm;
                if(!refForm.validate()){
                    return false;
                }
                if(this.newPassword !== this.newPasswordV){
                    this.newPassChk.error = true;
                    this.newPassChk.errMes = this.text.messege.newPasswordCheckV;
                    return false;
                }
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.my.changePassword({
                        "currentPassword":this.currentPassword,
                        "password":this.newPassword,
                        "otpCode":this.otpToken||undefined,
                    });
                    this.digChangePassword = false;
                    comm.LoadingOverlay(this,false);
                    if(apiResponse.statusCode === 200){
                        if(apiResponse.data.status === ePasswordChangeStatus.sccess){
                            comm.SuccessMessege(this,this.text.messege.dbSccess);
                        }else{
                            comm.WaringMessege(this,text.Text.authFail,null);
                        }
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            digTotpSetClose(){
                this.showP = false;
                this.password = "",
                this.digTotpSet = false;
            },
            clearTotpExec(){
                this.setTotpExecute(true);
            },
            setTotpExec(){
                this.setTotpExecute(false);
            },
            async setTotpExecute(clear:boolean){
                comm.LoadingOverlay(this,true);
                if(clear){
                    comm.LoadingOverlay(this,true);
                    if(this.api && this.api.connection && this.api.apiRequest){
                        const apiResponse = await this.api.apiRequest.request.my.totp.clearSecret(this.password,this.otpToken);
                        comm.LoadingOverlay(this,false);
                        if(apiResponse.statusCode === 200){
                            if(apiResponse.data){
                                this.digClearTotp = false;
                                comm.SuccessMessege(this,this.text.messege.dbSccess);
                                this.$emit("parentCall","logout");
                            }else{
                                comm.WaringMessege(this,text.Text.authFail,null);
                            }
                        }else if(apiResponse.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError);
                        }
                    }
                }else{
                    comm.LoadingOverlay(this,true);
                    if(this.api && this.api.connection && this.api.apiRequest){
                        const apiResponse = await this.api.apiRequest.request.my.totp.newSecret(this.password);
                        this.digChangePassword = false;
                        comm.LoadingOverlay(this,false);
                        if(apiResponse.statusCode === 200){
                            this.digTotpSet = false;
                            this.digTotpInfo = true;
                            this.totpKey = apiResponse.data.key;
                            this.totpQrCode = apiResponse.data.qrcodeDataUrl;
                        }else if(apiResponse.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError);
                        }
                    }
                }
            },
            passWordScoreCheck(){
                const checkResult = checkZxcvbn(this.newPassword);
                this.passwordScore.value = (checkResult.scoreRate>=100)?100:checkResult.scoreRate;
                this.passwordWarning = getWarningMessege(checkResult.feedback.warning);
                this.disPasswordChgBtn = typeof checkResult.passwordRule === "string"?true:false;
                if(checkResult.scoreRate >= 85){
                    this.passwordScore.color = "light-blue";
                    this.passwordScoreTxt = this.text.messege.passwordEvaluation.verystrong;
                }else if(checkResult.scoreRate >= 70){
                    this.passwordScore.color = "light-green";
                    this.passwordScoreTxt = this.text.messege.passwordEvaluation.strong;
                }else if(checkResult.scoreRate >= 50){
                    this.passwordScore.color = "amber";
                    this.passwordScoreTxt = this.text.messege.passwordEvaluation.soso;
                }else if(checkResult.scoreRate >= 35){
                    this.passwordScore.color = "deep-orange";
                    this.passwordScoreTxt = this.text.messege.passwordEvaluation.week;
                }else{
                    this.passwordScore.color = "pink";
                    this.passwordScoreTxt = this.text.messege.passwordEvaluation.fock;
                }
                if(this.newPassword.length === 0){
                    this.passwordScoreTxt = "";
                }
                if(this.passwordWarning.length !== 0){
                    this.passwordWarning = `${this.text.warning}:${this.passwordWarning}`;
                }
                return this.passwordScore.value;
            },
            async activateTotp(){
                if(this.activateToken){
                    this.disActTotoBtn = true;
                    this.activateFail = false;
                    comm.LoadingOverlay(this,true);
                    if(this.api && this.api.connection && this.api.apiRequest){
                        const apiResponse = await this.api.apiRequest.request.my.totp.activateSecret(this.activateToken)
                        comm.LoadingOverlay(this,false);
                        if(apiResponse.statusCode === 200){
                            if(apiResponse.data){
                                this.activateComplete = true;
                                this.activateToken = '';
                            }else{
                                this.disActTotoBtn = false;
                                this.activateFail = true;
                            }
                        }else if(apiResponse.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError);
                        }
                    }
                }
            },
            logout(){
                this.reset();
                this.$emit("parentCall","logout");
            }
        }
    });
</script>
